import { render, staticRenderFns } from "./yi-checkbox.vue?vue&type=template&id=767489d1&scoped=true&"
import script from "./yi-checkbox.vue?vue&type=script&lang=js&"
export * from "./yi-checkbox.vue?vue&type=script&lang=js&"
import style0 from "./yi-checkbox.vue?vue&type=style&index=0&id=767489d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767489d1",
  null
  
)

component.options.__file = "src/components/yi-checkbox/yi-checkbox.vue"
export default component.exports